import { connect } from 'react-redux'
import MyFilesTable from './my-files-table'
import { getMyFilesList } from '../../../../../stores/my-files/my-files.selectors'

const mapStateToProps = state => ({
  myFiles: getMyFilesList(state)
})

export default connect(mapStateToProps, null)(MyFilesTable)
